var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.winnerList.length)?_c('div',{staticClass:"broadcastContainer",style:(_vm.styleObj)},[_c('Rolling',{attrs:{"clipTime":"2000"}},_vm._l((_vm.winnerList),function(item){return _c('div',{key:item.id,staticClass:"broadcastItem"},[_vm._v("\n      "+_vm._s(item.content)+"\n    ")])}),0)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }